import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=a781daea&scoped=true"
import script from "./announcement.vue?vue&type=script&lang=ts"
export * from "./announcement.vue?vue&type=script&lang=ts"
import style0 from "./announcement.vue?vue&type=style&index=0&id=a781daea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a781daea",
  null
  
)

export default component.exports